// Single source of truth for all contact details shown across the site.

export const contact = {
  email: "care@theplanetapps.in",
  phone: "+91 96438 68080",
  phoneHref: "tel:+919643868080",
  emailHref: "mailto:care@theplanetapps.in",
  address: {
    line1: "105, A1 Building",
    line2: "Sector 59, Noida, Uttar Pradesh, India",
    full: "105, A1 Building, Sector 59, Noida, Uttar Pradesh, India",
  },
} as const;
